/* ============================================================================
 * CSS compartilhado das telas de DOCUMENTOS FISCAIS.
 *
 * Mesma linguagem visual do `FiscalInvoiceListPage` (features/fiscal): tabela
 * densa com cabeçalho mono uppercase, status em pill, KPIs em cards, toolbars
 * de filtro e estados de vazio honestos. Cada página injeta este bloco via
 * `<style>` — como o FiscalInvoiceListPage faz com o próprio bloco.
 * ========================================================================== */

export const FISCAL_DOCUMENTS_CSS = `
  .fiscal-page { padding: 1.5rem; }

  .fiscal-tabs { display: flex; gap: 0.25rem; border-bottom: 1px solid #c4c6cf; margin-bottom: 1.5rem; flex-wrap: wrap; }
  .fiscal-tab {
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    padding: 0.5rem 0.875rem;
    font: inherit;
    font-size: 0.875rem;
    color: #43474e;
    cursor: pointer;
  }
  .fiscal-tab:hover { color: #002045; }
  .fiscal-tab.is-active { color: #002045; border-bottom-color: #002045; font-weight: 600; }

  .fiscal-kpi { background: #ffffff; border: 1px solid #c4c6cf; border-radius: 8px; padding: 1rem; box-shadow: 0 1px 2px rgba(0,0,0,.04); }
  .fiscal-kpi__top { display: flex; align-items: center; gap: 0.375rem; margin-bottom: 0.25rem; }
  .fiscal-kpi__top .material-symbols-outlined { font-size: 18px; color: #43474e; }
  .fiscal-kpi--ok { color: #1b7f4d; }
  .fiscal-kpi--info { color: #002045; }
  .fiscal-kpi--bad { color: #ba1a1a; }
  .fiscal-kpi--muted { color: #43474e; }

  .fiscal-toolbar { display: flex; flex-wrap: wrap; align-items: center; gap: 0.75rem; margin-bottom: 1rem; }
  .fiscal-control {
    padding: 0.5rem;
    background: #f7f9fb;
    border: 1px solid #c4c6cf;
    border-radius: 2px;
    font: inherit;
    font-size: 0.875rem;
    color: #191c1e;
    min-width: 260px;
  }
  .fiscal-control--select { min-width: 200px; cursor: pointer; }
  .fiscal-control:focus { outline: none; border-color: #002045; box-shadow: 0 0 0 1px #002045; }
  .fiscal-count { margin-left: auto; font-family: 'JetBrains Mono', ui-monospace, monospace; font-size: 12px; color: #43474e; }

  .fiscal-card { background: #ffffff; border: 1px solid #c4c6cf; border-radius: 8px; box-shadow: 0 1px 2px rgba(0,0,0,.04); overflow: hidden; }
  .fiscal-table { overflow-x: auto; }
  .fiscal-table table { width: 100%; border-collapse: collapse; }
  .fiscal-table thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f2f4f6;
    border-bottom: 1px solid #c4c6cf;
    padding: 0.5rem 0.75rem;
    text-align: left;
    font-family: 'JetBrains Mono', ui-monospace, monospace;
    font-size: 10px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #43474e;
    white-space: nowrap;
  }
  .fiscal-table tbody td { padding: 0.625rem 0.75rem; border-bottom: 1px solid #eceef0; font-size: 0.875rem; color: #191c1e; vertical-align: middle; }
  .fiscal-table tbody tr:hover { background: #f7f9fb; }
  .fiscal-mono, .fiscal-key { font-family: 'JetBrains Mono', ui-monospace, monospace; font-size: 12px; white-space: nowrap; }
  .fiscal-key { color: #43474e; font-size: 11px; }
  .fiscal-nowrap { white-space: nowrap; }
  .fiscal-num { text-align: right; font-family: 'JetBrains Mono', ui-monospace, monospace; font-variant-numeric: tabular-nums; white-space: nowrap; }
  .fiscal-recipient { display: block; }
  .fiscal-recipient-doc { display: block; font-family: 'JetBrains Mono', ui-monospace, monospace; font-size: 11px; color: #43474e; }
  .fiscal-status-icon { font-size: 14px; vertical-align: -3px; margin-right: 2px; }
  .fiscal-actions { text-align: right; white-space: nowrap; }

  .fiscal-footer { display: flex; align-items: center; justify-content: space-between; gap: 1rem; padding: 0.75rem 1rem; border-top: 1px solid #c4c6cf; }
  .fiscal-state { padding: 3rem 1rem; text-align: center; color: #43474e; font-size: 0.875rem; }
  .fiscal-state__title { margin: 0 0 0.5rem; font-weight: 600; color: #ba1a1a; }
  .fiscal-state__detail { margin: 0 0 1rem; }

  /* Detalhe em modal (GET /fiscal/invoices/:id) */
  .fiscal-detail-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0.75rem 1.5rem; }
  .fiscal-detail-grid .span-2 { grid-column: 1 / -1; }
  .fiscal-detail-item .label { font-family: 'JetBrains Mono', ui-monospace, monospace; font-size: 10px; letter-spacing: 0.04em; text-transform: uppercase; color: #43474e; margin-bottom: 0.125rem; }
  .fiscal-detail-item .value { font-size: 0.875rem; color: #191c1e; word-break: break-word; }
  .fiscal-detail-item .value--mono { font-family: 'JetBrains Mono', ui-monospace, monospace; font-size: 12px; }
  .fiscal-detail-actions { display: flex; gap: 0.75rem; margin-top: 1rem; flex-wrap: wrap; }

  /* Formulários (de-para, CC-e) */
  .fiscal-form { display: flex; flex-direction: column; gap: 1rem; }
  .fiscal-form__row { display: flex; flex-direction: column; gap: 0.375rem; }
  .fiscal-form__label { font-size: 0.8125rem; font-weight: 600; color: #191c1e; }
  .fiscal-form__hint { font-size: 0.75rem; color: #43474e; }
  .fiscal-form__error { font-size: 0.75rem; color: #ba1a1a; }
  .fiscal-form input, .fiscal-form textarea, .fiscal-form select {
    padding: 0.5rem;
    background: #f7f9fb;
    border: 1px solid #c4c6cf;
    border-radius: 2px;
    font: inherit;
    font-size: 0.875rem;
    color: #191c1e;
    width: 100%;
    box-sizing: border-box;
  }
  .fiscal-form input:focus, .fiscal-form textarea:focus, .fiscal-form select:focus {
    outline: none; border-color: #002045; box-shadow: 0 0 0 1px #002045;
  }
  .fiscal-form textarea { min-height: 96px; resize: vertical; }

  .fiscal-cloud { margin-top: 1rem; background: #f7f9fb; border: 1px solid #c4c6cf; border-radius: 6px; padding: 0.75rem; font-family: 'JetBrains Mono', ui-monospace, monospace; font-size: 11px; color: #43474e; white-space: pre-wrap; word-break: break-all; max-height: 220px; overflow: auto; }
`;